export const FREQUENCY_SUFFIX = {
  PER_DAY: 'per day',
  PER_WEEK: 'per week',
  PER_MONTH: 'per month',
};

export const planCreationStateEnum = {
  0: 'UNSPECIFIED',
  1: 'CREATE_PLAN',
  2: 'CREATE_POLICY',
  3: 'REVIEW_PROGRAM',
  UNSPECIFIED: 0,
  CREATE_PLAN: 1,
  CREATE_POLICY: 2,
  REVIEW_PROGRAM: 3,
};

export const createPlanSteps = [
  { id: 1, title: 'Meal plan details' },
  { id: 2, title: 'Setup policy' },
  { id: 3, title: 'Review details' },
];

export const days = [
  { value: 1, label: 'Mon' },
  { value: 2, label: 'Tue' },
  { value: 3, label: 'Wed' },
  { value: 4, label: 'Thu' },
  { value: 5, label: 'Fri' },
  { value: 6, label: 'Sat' },
  { value: 7, label: 'Sun' },
];

export const business = [
  { value: 1, label: 'Delivery' },
  { value: 2, label: 'Dining' },
];

export const ApplicabilityRule = {
  APPLICABILITY_RULE_UNSPECIFIED: 0,
  APPLICABILITY_RULE_INCLUSIVE: 1,
  APPLICABILITY_RULE_EXCLUSIVE: 2,
  0: 'APPLICABILITY_RULE_UNSPECIFIED',
  1: 'APPLICABILITY_RULE_INCLUSIVE',
  2: 'APPLICABILITY_RULE_EXCLUSIVE',
};

export const cardStyle = {
  scroll: true,
  hideScroll: true,
  bodyPx: '2rem',
  bodyPy: '1rem',
  footerPy: '1rem',
  footerPx: '2rem',
  justifyHeader: 'space-evenly',
  justifyFooter: 'space-between',
  headerShadow: false,
  footerShadow: false,
};
